<template>
    <div>
        <div class="border-table padding-th" v-for="(item, index) in load_type_course" :key="index">
            <slot :item="item"/>
        </div>
    </div>

</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "Lesson",
    props:{
        course:{
            type:Object,
        }
    },
    computed:{
        ...mapGetters({
            GET_STUDY_PLAN_APPLICATIONS:'system_settings/GET_STUDY_PLAN_APPLICATIONS',
        }),
        load_type_course(){
            return this.GET_STUDY_PLAN_APPLICATIONS.filter((item)=>{
                if (item.lesson.flux.course.uid === this.course.uid){
                    return item
                }
            })
        }
    }
};
</script>

<style scoped>
.border-table{
    border-bottom: 2px solid #f2f2f8;
}
.border-table:last-child{
    border-bottom: 0px;
}
.padding-th{
    padding: 20px 10px;
}
</style>
